/**
 * Wishlist (favoris) en localStorage.
 * - Bouton coeur sur fiche produit ⇄ ajouter / retirer
 * - Compteur dans le header
 * - Page wishlist : liste rendue dynamiquement via Section Rendering API
 */
(function () {
  const STORAGE_KEY = 'wishlistProducts';
  const CHANGED_EVENT = 'wishlist:changed';

  function read() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent(CHANGED_EVENT, { detail: { count: list.length, list } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    const list = read();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle); else list.splice(idx, 1);
    write(list);
    return idx === -1;
  }
  function remove(handle) {
    const list = read().filter((h) => h !== handle);
    write(list);
  }

  window.LeMielWishlist = { read, has, toggle, remove, CHANGED_EVENT };

  // ---- Custom Element : bouton coeur ----
  if (!customElements.get('wishlist-toggle')) {
    class WishlistToggle extends HTMLElement {
      connectedCallback() {
        this.handle = this.dataset.handle;
        this.btn = this.querySelector('button');
        if (!this.handle || !this.btn) return;
        this.refresh();
        this.btn.addEventListener('click', (e) => {
          e.preventDefault();
          const added = toggle(this.handle);
          this.btn.setAttribute('aria-pressed', String(added));
          this.refresh();
          if (this.btn.dataset.feedback !== 'silent') {
            this.btn.classList.add('wishlist-toggle--bump');
            setTimeout(() => this.btn.classList.remove('wishlist-toggle--bump'), 400);
          }
        });
        document.addEventListener(CHANGED_EVENT, () => this.refresh());
      }
      refresh() {
        const active = has(this.handle);
        this.btn.setAttribute('aria-pressed', String(active));
        this.classList.toggle('is-active', active);
        const label = this.btn.querySelector('.wishlist-toggle__label');
        if (label) label.textContent = active ? 'Retirer des favoris' : 'Ajouter aux favoris';
      }
    }
    customElements.define('wishlist-toggle', WishlistToggle);
  }

  // ---- Custom Element : compteur header ----
  if (!customElements.get('wishlist-count')) {
    class WishlistCount extends HTMLElement {
      connectedCallback() {
        this.refresh();
        document.addEventListener(CHANGED_EVENT, () => this.refresh());
      }
      refresh() {
        const count = read().length;
        this.textContent = count > 0 ? String(count) : '';
        this.style.display = count > 0 ? '' : 'none';
      }
    }
    customElements.define('wishlist-count', WishlistCount);
  }

  // ---- Custom Element : grille de la page wishlist ----
  if (!customElements.get('wishlist-grid')) {
    class WishlistGrid extends HTMLElement {
      async connectedCallback() {
        this.sectionId = this.dataset.sectionId || 'wishlist-grid';
        this.empty = this.querySelector('[data-wishlist-empty]');
        this.target = this.querySelector('[data-wishlist-target]');
        await this.render();
        document.addEventListener(CHANGED_EVENT, () => this.render());
      }
      async render() {
        const handles = read();
        if (handles.length === 0) {
          if (this.target) this.target.innerHTML = '';
          if (this.empty) this.empty.hidden = false;
          return;
        }
        if (this.empty) this.empty.hidden = true;
        try {
          const url = '/?section_id=' + encodeURIComponent(this.sectionId) +
                      '&handles=' + encodeURIComponent(handles.join(','));
          const res = await fetch(url);
          if (!res.ok) return;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-wishlist-target]');
          if (inner && this.target) this.target.innerHTML = inner.innerHTML;
        } catch (e) { /* silencieux */ }
      }
    }
    customElements.define('wishlist-grid', WishlistGrid);
  }
})();
